import { Keyword, ModelType } from '@livv/models';
import { getThematicPlanLink } from '@livv/utils/helpers';
import { FC, Fragment } from 'react';
import { PlainLink } from '@components/Links';
import { INDEX_NAME } from '@utils/consts/search';

interface LinksTitlesProps {
    keyword: Keyword;
    maxTitleItems?: number;
    onClick: () => void;
    theme: string;
    titles: string[];
}

const LinksTitles: FC<LinksTitlesProps> = ({ keyword, maxTitleItems, onClick, theme, titles }) => {
    const { path, treeId } = keyword;
    const titlesToShow = maxTitleItems === undefined ? titles : titles.slice(0, maxTitleItems);

    return (
        <>
            {titlesToShow.map((title, i) => (
                <Fragment key={title}>
                    <PlainLink
                        href={getThematicPlanLink(
                            theme,
                            INDEX_NAME,
                            { path: path.slice(0, i + 1), treeId },
                            ModelType.DECISION,
                            true,
                        )}
                        onClick={onClick}
                        sx={{ color: 'inherit', fontWeight: 'regular', lineHeight: 1 }}
                        openInNewTab
                    >
                        {title}
                    </PlainLink>
                    {i + 1 < titles.length && ' > '}
                </Fragment>
            ))}
        </>
    );
};

export default LinksTitles;
